import httpClient from '../httpClient';

export const getAllMedsusDiretrizVmp = async () => {
  try {
    const response = await httpClient.get(`/api/medsusdiretrizvmp`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
};

export const getAllMedsusDiretrizVmpByDiretrizId = async (
  diretrizId: string,
) => {
  try {
    const response = await httpClient.get(
      `/api/medsusdiretrizvmp/diretriz/${diretrizId}`,
    );
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
};

export async function getMedsusDiretrizVmp(id: string) {
  try {
    const response = await httpClient.get(`/api/medsusdiretrizvmp/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}
